import { render, staticRenderFns } from "./quality.vue?vue&type=template&id=6f824c6f&scoped=true&"
import script from "./quality.vue?vue&type=script&lang=js&"
export * from "./quality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f824c6f",
  null
  
)

export default component.exports